<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  created() {
    if (this.$store.state.isMobile
      && this.$store.state.isSafari) {
      if (this.$store.state.iosv && this.$store.state.iosv.major <= 10) {
        this.$router.push({ name: 'Update' })
        return
      }

      if (screen.width <= 320 && screen.height <= 568 && window.navigator.standalone === false) {
        this.$router.push({ name: 'ScreenInfo' })
      }
    }
  },
}
</script>

<style lang="scss">

@import "src/reset.scss";
@import "src/style.scss";

.agile__track {
  pointer-events: none;
}

button {
  pointer-events: all;
}
</style>



// WEBPACK FOOTER //
// src/App.vue